var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowFat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 156.32a46.65 46.65 0 01-33-79.65l33-33 33 33a46.66 46.66 0 01-33 79.65zm0-102.92L71.87 81.53a39.78 39.78 0 1056.26 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.69 139.62v-6.88a22.41 22.41 0 0022.39-22.39H130a29.3 29.3 0 01-29.31 29.27z"
  })));
}
export default SvgLowFat;